usingPossibleTypes